export const SET_COMMISSION_DUE_INDEX =
  'CommissionDue/SET_COMMISSION_DUE_INDEX';
export const COMMISSION_DUE_INDEX_FAILED =
  'CommissionDue/COMMISSION_DUE_INDEX_FAILED';
export const LOAD_COMMISSION_DUE_INDEX =
  'CommissionDue/LOAD_COMMISSION_DUE_INDEX';

export const setCommissionDueIndex = payload => ({
  type: SET_COMMISSION_DUE_INDEX,
  payload
});

export const commissionDueIndexFailed = () => ({
  type: COMMISSION_DUE_INDEX_FAILED
});

export const loadCommissionDueIndex = () => ({
  type: LOAD_COMMISSION_DUE_INDEX
});

const initialState = {
  loading: true,
  failedLoad: false,
  expandedRowCurrency: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_COMMISSION_DUE_INDEX:
      return {
        ...state,
        ...action.payload,
        failedLoad: false,
        loading: false
      };
    case COMMISSION_DUE_INDEX_FAILED:
      return {
        ...state,
        failedLoad: true
      };

    default:
      return state;
  }
};
